import { WatchlistParameters } from 'app/modules/detectionModels/components/scenarioWidgets/watchlist/models';
import { CompositeQueryTreeNode } from 'app/modules/rulesAdvanced/models';

export const validateWatchlistContentStep = (
  watchlist: WatchlistParameters | undefined,
  dynamicFactFilter: CompositeQueryTreeNode | null,
): boolean => {
  if (!watchlist) return false;
  if (!watchlist.name || watchlist.name.length === 0) return false;
  if (!watchlist.entity_type) return false;
  if (!isMatchThresholdValid(watchlist.match_threshold)) {
    return false;
  }
  if (dynamicFactFilter?.operands?.length === 0) {
    return false;
  }
  if (watchlist.match_fields.length === 0) return false;
  if (!watchlist.is_specification_valid) return false;
  return true;
};

export const isMatchThresholdValid = (
  matchThreshold: number | undefined,
): boolean => {
  if (matchThreshold === undefined) return false;
  return matchThreshold >= -10 && matchThreshold <= 10;
};
